import React from 'react';
import { ShortSalesPage } from './pages/ShortSalesPage';
export function App() {
  return <ShortSalesPage data-id="element-0" />;
}